import { Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "../styles.css";
import AboutUS from "../images/aboutus.png";
const useStyles = makeStyles((theme) => ({
  aboutImageContainer: {
    paddingRight: 100,
    "& img": {
      width: "100%",
      maxWidth: "100%"
    },
    [theme.breakpoints.down("md")]: {
      paddingRight: 0,
      textAlign: "center",
      marginBottom: 30,

      "& img": {
        width: "auto",
        maxHeight: 300
      }
    },
    [theme.breakpoints.up("md") && theme.breakpoints.down("lg")]: {
      paddingRight: 30
    }
  },
  aboutHeading: {
    lineHeight: 1.4,
    fontSize: 28,
    fontWeight: 600,
    textTransform: "capitalize",
    color: "#535772",
    marginBottom: 40,
    font: "normal normal 600 46px/69px Poppins",
    [theme.breakpoints.down("sm")]: {
      fontSize: 20
    }
  },
  aboutDescription: {
    lineHeight: 1.8,
    marginBottom: 12
  },
  aboutContainer: {
    padding: "80px 0",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      padding: "50px 0"
    }
  },
  specialText: {
    fontWeight: 700,
    fontSize: "1.15rem",
    color: "#2498FB",
    position: "relative",
    "&:before": {
      position: "absolute",
      content: "",
      top: -6,
      height: 2,
      width: "80%",
      left: 0,
      backgroundolor: "red"
    },
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      fontSize: 15
    }
  },
  aboutTextContainer: {
    textAlign: "l,eft",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  }
}));

const About = ({ id }) => {
  const classes = useStyles();
  return (
    <div className={classes.aboutContainer} id={"about"}>
      <Typography variant="body2" className={classes.specialText}>
        A B O U T &nbsp; U S
      </Typography>
      <Typography variant="h1" className={classes.aboutHeading}>
        Get to know Us
      </Typography>

      <Grid
        container
        style={{ maxWidth: "95%" }}
        alignItems="flex-start"
        justify="space-around"
        spacing={4}
      >
        <Grid xs={12} md={5}>
          <div className={classes.aboutImageContainer}>
            <img src={AboutUS} alt="about us " />
          </div>
        </Grid>

        <Grid className={classes.aboutTextContainer} xs={12} md={5}>
          <Typography variant="body1" className={classes.aboutDescription}>
            We started as a team of two to gain experience and liked the way we
            can help businesses. Now we are operating as a full Fledged digital
            agency with every type of digital products in our box.
          </Typography>
          <Typography variant="body1" className={classes.aboutDescription}>
            Our main goal is to help you reach your goals by our digital
            products.
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};
export default About;
